import { render, staticRenderFns } from "./AuditTrailModal.vue?vue&type=template&id=12636532"
import script from "./AuditTrailModal.vue?vue&type=script&lang=js"
export * from "./AuditTrailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports